import * as Yup from 'yup'
// import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react'
import { useSnackbar } from 'notistack'
import { useLocation, useNavigate } from 'react-router-dom'
import { Form, FormikProvider, useFormik } from 'formik'
import { useTheme } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import plusFill from '@iconify/icons-eva/plus-fill'
import trash2Outline from '@iconify/icons-eva/trash-2-outline'
import editFill from '@iconify/icons-eva/edit-fill'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
import { LoadingButton } from '@material-ui/lab'
import { experimentalStyled as styled } from '@material-ui/core/styles'
import { Draggable, Droppable, DragDropContext } from "react-beautiful-dnd";

import {
  Container,
  Stack,
  Switch,
  Box,
  Typography,
  FormControlLabel,
  Grid,
  Card,
  TextField,
  Button,
  MenuItem,
  MenuList,
  Divider,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Autocomplete,
  IconButton,
  Menu,
  ListItemIcon,
  ListItemText,
  Popover,
  Paper,
  Tooltip,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
//components
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs'
import Page from 'src/components/Page'
import {
  AccountBalance,
  AccountCircle,
  Assignment,
  AssignmentInd,
  DeleteOutlineOutlined,
  Edit,
  KeyboardBackspaceOutlined,
  MonetizationOn
} from '@material-ui/icons'
import Modal from 'src/components/_dashboard/blog/ProjectModel'
import { PATH_DASHBOARD } from 'src/routes/paths'
import axios from 'axios'
import { REST_API_END_POINT, REST_API } from 'src/constants/Defaultvalues'

import moment from 'moment'
import { sentenceCase } from 'change-case'
import { event } from 'jquery'
import { type } from '@testing-library/user-event/dist/type'
import { empty } from 'src/Helpers/Common'
import LoadingScreen from 'src/components/LoadingScreen'



const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  paddingTop: 'calc(100% * 9 / 16)',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    //  backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)', // Fix on Mobile
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,
    // backgroundColor: alpha(theme.palette.primary.darker, 0.72)
  },
}))
// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  // Split into parts: strings and numbers
  const partsA = a.match(/(\d+|\D+)/g) || [];
  const partsB = b.match(/(\d+|\D+)/g) || [];

  // Compare each part
  const minLength = Math.min(partsA.length, partsB.length);
  for (let i = 0; i < minLength; i++) {
    const partA = partsA[i];
    const partB = partsB[i];

    // If both parts are numbers, compare numerically
    if (/^\d+$/.test(partA) && /^\d+$/.test(partB)) {
      const numA = parseInt(partA, 10);
      const numB = parseInt(partB, 10);
      if (numA !== numB) {
        return numA - numB;
      }
    } else {
      // Otherwise, compare as strings (case-insensitive)
      const strCompare = partA.localeCompare(partB, undefined, { sensitivity: 'base' });
      if (strCompare !== 0) {
        return strCompare;
      }
    }
  }

  // If all parts are equal, shorter string comes first
  return partsA.length - partsB.length;
}

const BANK_DETAILS = [
  {
    id: 1,
    name: 'CC/DC Authorization Form',
  },
  {
    id: 2,
    name: 'ACH Authorization Form',
  },
]
// const ACTIONSTAGE=[
//     {
//         id: 7,
//         icon: <AccountCircle />,
//         label: 'Action Stage',
//         session: 'onboard_stages',
//         type: 'action-stage',
//       },
// ]
const ClientFacing = [
  {
    id: 1,
    icon: <AccountCircle />,
    label: 'Data Collection',
    session: 'onboard_stages',
    type: 'data-collection',
  },
  // {
  //   id: 2,
  //   icon: <AccountBalance />,
  //   label: 'Bank Information',
  //   session: 'onboard_stages',
  //   type: 'bank-information',
  //   shot: 'bank',
  // },
  // {
  //   id: 3,
  //   icon: <MonetizationOn />,
  //   label: 'Tax Information',
  //   session: 'onboard_stages',
  //   shot: 'tax',
  //   type: 'tax-information',
  // },
  // {
  //   id: 4,
  //   icon: <AccountCircle />,
  //   label: 'Portfolio',
  //   session: 'onboard_stages',
  //   type: 'portfolio',
  //   shot: 'previous works',
  // },
  // {
  //   id: 5,
  //   icon: <AssignmentInd />,
  //   label: 'Questionnaire',
  //   session: 'onboard_stages',
  //   type: 'questionnaire',
  // },
  // {
  //   id: 6,
  //   icon: <Assignment />,
  //   label: 'Sign Agreement',
  //   session: 'onboard_stages',
  //   type: 'sign-agreement',
  // },
]
const InternalData = [
  {
    id: 1,
    icon: <AccountCircle />,
    label: 'Data Collection',
    session: 'internal_stages',
    type: 'data-collection',
  },
  {
    id: 5,
    icon: <AssignmentInd />,
    label: 'Questionnaire',
    session: 'internal_stages',
    type: 'questionnaire',
  },
]
const stageTypes=(types)=>{

  switch (types) {
    case 1:
      return { label: 'Data Collection',session: 'onboard_stages',type: 'data-collection', }
      case 2:
        return {label:'Bank Information',session: 'onboard_stages', type: 'bank-information', shot: 'bank',}
        case 3:
          return { label: 'Tax Information',session: 'onboard_stages', shot: 'tax',  type: 'tax-information',}
          case 4:
            return {label: 'Portfolio', session: 'onboard_stages', type: 'portfolio',  shot: 'previous works',}
            case 5:
              return { label: 'Questionnaire',session: 'onboard_stages',type: 'questionnaire',}
              case 6:
                return {label: 'Sign Agreement',session: 'onboard_stages',type: 'sign-agreement',}
                case 7 :
                  return { label: 'Action Stage',session: 'onboard_stages', type: 'action-stage',}
  }
}
export default function AddNewWorkFlow({fromProducts, setOpenWorkflowModal, selectedWorkflowId, onWorkflowCreated}) {
  const user = localStorage.getItem('user')
  const userData = JSON.parse(user)
  const buttonRef = useRef()
  const location = useLocation()
  const isEdit = selectedWorkflowId ? true : location?.state?.isEdit
  const productWorkflow= selectedWorkflowId ? true : location?.state?.productWorkflow
  const workflowId = selectedWorkflowId ? selectedWorkflowId : location?.state?.id
  const [openClientAutoComplete,setOpenClientAutoComplete] = useState(false)
  const [openRelationAutoComplete,setOpenRelationAutoComplete] = useState(false)
  // const [openGroup,setOpenGroup] = useState(false)
  const [clickClient, setClickClient] = useState(true)
  const [internal, setInternal] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [templates, setTemplates] = useState(null)
  const [signAgreement, setSignAgreeMent] = useState(null)
  const [questions, setQuestions] = useState(null)
  const [documents, setDocuments] = useState(null)
  const [partnerTypes,setPartnerTypes] = useState(null)
  const [groups,setGroups] = useState(null)
  const [managers,setManagers] = useState(null)
  const [stageDetail, setStageDetail] = useState()
  const [newDocument, setNewDocument] = useState('')
  const [skills,setSkills] = useState([])
  const [allServices,setAllServices] = useState([])
  const [isLoading,setIsLoading]=useState(false)
  const [isLoadingSkills,setIsLoadingSkills]=useState(false)
  const [isSaving,setIsSaving]=useState(false)
  const [editStage,setEditStage]=useState(null)
  const [loading,setLoading]=useState(false)
  const [savedStages,setSavedStages] = useState([])
  const [stageSubmit, setStageSubmit] = useState({
    name: '',
    isDefault: false,
  })
  const [openBackConfirm, setOpenBackConfirm] = useState(false)
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate()
  const theme = useTheme()

  const NewUserSchema = Yup.object().shape({
    bank_details: stageDetail?.label === 'Bank Information' && Yup.array().min(1, 'Bank detail is required'),
    template: stageDetail?.label === 'Data Collection' && Yup.array().min(1, 'Custom Template is required'),
    services: stageDetail?.label === 'Data Collection' &&  Yup.object().nullable().required('Please select a service'),
    agreements: stageDetail?.label === 'Sign Agreement' && Yup.array().min(1, 'Agreement is required'),
    questions: stageDetail?.label === 'Questionnaire' && Yup.array().min(1, 'Questionaire Template is required'),
    stage_name:Yup.string().required('Name is required')
  })
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  }))
  //
  const ClickClientFacing = () => {
    setClickClient(!clickClient)
    setInternal(false)
  }
  const ClickInternal = () => {
    setClickClient(false)
    setInternal(!internal)
  }
 const fetchWorkFlowbyId=async()=>{
  try {
    setIsLoading(true);
    setLoading(true)
    if(isEdit===true){
      let res = await axios.post(`${REST_API_END_POINT}onboard/fetch-workflow-id`,{id:workflowId})
      let  stages = res.data.onboard_stages
      const result = stages.map(stage => {
        const clientFaceMapping = ClientFacing.find(clientFace => clientFace.id === stage.stage_type);
        
        if (clientFaceMapping) {
            let { id, label, session, type,shot } = clientFaceMapping;
            if(stage.internal_stage==1){
              session="internal_stages"
            }
            stage.stage_type = {
                id,
                label,
                session,
                type,
                shot
                
            };
        }
        if(stage.type_of_stage==1){
          stage.type_of_stage="Automatic"
        }
        
          stage.description=stage.exit_message||""
          stage.order= stage.position_order
          // stage["partnerTypes"].id=stage.partner_type 
          if(!empty(stage.field_template_ids)){
            stage.template=stage.field_template_ids.map(id => ({ id }));
          }
          
          if(!empty(stage.bank_form_type)){
          
            stage.bank_details=stage.bank_form_type.map(id => ({ id }));
          }
         if(!empty(stage.requested_document_ids)){
          stage.documents=stage.requested_document_ids.map(id => ({ id }));
         }
       if(!empty(stage.sign_agreement_ids))
          {
            stage.agreements=stage.sign_agreement_ids.map(id => ({ id }));
          }
          if(!empty(stage.questionnaire_ids)){
            stage.questions=stage.questionnaire_ids.map(id => ({ id }));
          }
          if(!empty(stage.name)){
            stage.stage_name=stage.name
          }
          if(!empty(stage.service_id)){
            stage.new_service_name = allServices?.find(item=>item?.id == stage.service_id)?.name || ''
          }
          
    
        return stage;
    });
    
      setSavedStages(result)

      setStageSubmit({
        name:res.data.workflow[0].name,
        isDefault:res.data.workflow[0].is_default ==1 ? true: res.data.workflow[0].is_default == 0 ?false : false
      })
    }
  } catch (error) {
    console.log(error,'error in fetching onboard')
  }finally{
    setIsLoading(false)
    setLoading(false)
  }
 }

 useEffect(()=>{
  fetchAllServices()
  fetchWorkFlowbyId()
 },[isEdit])


  const handleDeleteStage = (id) => {
    let  updatedstage = savedStages?.filter((stage) => stage.id !== id);
     setSavedStages(updatedstage)
  }
  const fetchSkills=async()=>{
    try {
      const response = await axios.post(`${REST_API_END_POINT}settings/get-all-settings`, {
        userId:userData.user_id,userType:userData.user_type
      })
      let data = response.data.results.services;
      // Sort alphanumerically by name
      const sortedData = [...(data || [])].sort((a, b) => 
        alphanumericCompare(a?.name || '', b?.name || '')
      );
      setSkills(sortedData)    
    } catch (error) {
      console.log(error)
    }
  }

  const fetchAllServices = async () => {
    try {
      const servRes = await axios.post(`${REST_API}webservice/product/get-all-labour-cost-services-only`,{});
      setAllServices(servRes.data.labourCostServices);
    } catch (servicesError) {
      console.error('Error fetching services:', servicesError);
      setAllServices([]);
    }
  };
 
  const fetchDataforSidePanel = async (val) => {
    try{
      setIsLoadingSkills(true)
    fetchSkills()
    let res = await axios.post(`${REST_API_END_POINT}onboard/load-sidepanel`, {
      sessionVariable: val?.session,
      userId: userData.user_id,
      layout: val?.type,
      internalStage: 0,
    })

    // Sort all data alphanumerically
    const sortedTemplates = [...(res.data.data.field_templates || [])].sort((a, b) => 
      alphanumericCompare(a?.name || '', b?.name || '')
    );
    const sortedAgreements = [...(res.data.data.sign_agreements || [])].sort((a, b) => 
      alphanumericCompare(a?.name || '', b?.name || '')
    );
    const sortedQuestions = [...(res.data.data.questionnaires || [])].sort((a, b) => 
      alphanumericCompare(a?.name || '', b?.name || '')
    );
    const sortedPartnerTypes = [...(res.data.data.partner_types || [])].sort((a, b) => 
      alphanumericCompare(a?.name || '', b?.name || '')
    );
    const sortedManagers = [...(res.data.data.staff_members || [])].sort((a, b) => 
      alphanumericCompare((a?.first_name || '') + (a?.last_name || ''), (b?.first_name || '') + (b?.last_name || ''))
    );
    
    setTemplates(sortedTemplates)
    setDocuments(res.data.data.requested_documents)
    setSignAgreeMent(sortedAgreements)
    setQuestions(sortedQuestions)
    setPartnerTypes(sortedPartnerTypes)
    setGroups(res.data.data.groups)
    setManagers(sortedManagers)
    }catch(err){
      console.log('error in sidepanel fetch',err)
    }finally{
      setIsLoadingSkills(false)
    }
  }
  const HandleClickToForm = (val) => {
    // When adding a new stage (e.g. Data Collection), ensure we are not
    // carrying over any previous edited stage values.
    setEditStage(null)
    setStageDetail(val)
    fetchDataforSidePanel(val)
    setOpenModal(true)
  }
  //--------------------------------------------
let  initialtemplate=[]

// initialtemplate = templates?.filter(template => editStage?.template?.includes(item => item.id === template.id))

 initialtemplate = templates?.filter(template => editStage?.template?.some(item => item.id === template.id));
let initialAgreement=signAgreement?.filter(aggrement=>editStage?.agreements?.some(item => item.id === aggrement.id))
let initialQuestionaire = questions?.filter(quest=>editStage?.questions?.some(item => item.id === quest.id))
let initialgroup= groups?.filter((group)=>editStage?.group_ids?.includes(String(group.id)))
let initialDocuments=[]
  initialDocuments = documents?.filter((doc)=>editStage?.documents?.some(item => item.id === doc.id))
let initialManagers = managers?.filter((person)=>editStage?.relationship_manager_ids?.includes(String(person.id)))
let initialBankDocs = BANK_DETAILS?.filter((bank)=>editStage?.bank_details?.some(item =>{
  
  return (item.id.toString()) == (bank.id.toString())} ))

 let initialPartner = []

if(openClientAutoComplete){
  initialPartner = partnerTypes?.filter(partner=>editStage.partner_types == partner.id)
}
let initialSkills = skills?.filter(data=>editStage?.skill_ids?.includes(String(data.id)))
let initialService = allServices?.find(data=>editStage?.service_id == data.id)

const  handleEditStage=(value)=>{

  if(isEdit == true){
   console.log('***88*8',value)
    setEditStage(value)
  let editdata = stageTypes(value.stage_type)

    setStageDetail(value.stage_type)
    fetchDataforSidePanel(value.stage_type)
  }
  else{
    
  setEditStage(value)
  setStageDetail(value?.stage_type)
  fetchDataforSidePanel(value?.stage_type)
  }
  setOpenModal(true)
}

 const sumbmitOnboard=async(event)=>{
    try {
        event.preventDefault();
        if (stageSubmit.name.trim() === '') {
           return;
        }
        if(savedStages.length==0){
          enqueueSnackbar('Please add at least one stage!',{variant:'warning'})
          return
        }
        let noServiceData = [];
        savedStages.forEach(stage => {
          // Check if the stage does not have 'services' or 'service_id'
          if (!stage.services && !stage.service_id) {
            // Add the stage to the noServiceData array
            noServiceData.push(stage);
          }
        });
        if(noServiceData.length > 0){
          enqueueSnackbar('Please add a service to the stage!',{variant:'warning'})
          return
        }
        if(isEdit ==true){
          console.log('productWorkflow-----------');
          let response = await axios.post(`${REST_API_END_POINT}onboard/edit-workflow`,{
            stageSubmit,savedStages,userId:userData.user_id,workflowId:workflowId,productWorkflow
          })
          if(response.data.status ==1){
            enqueueSnackbar(response.data.message,{variant:'success'})
            if(fromProducts){
              setOpenWorkflowModal(false)
              onWorkflowCreated(workflowId)
            }else{
              navigate(PATH_DASHBOARD.onboard.productWorkflow)
            }
            setSavedStages(null)
          }else{
            enqueueSnackbar(response.data.message,{variant:'error'})
            if(fromProducts){
              setOpenWorkflowModal(false)
            }else{
              navigate(PATH_DASHBOARD.onboard.productWorkflow)
            }
            setSavedStages(null)
          }
        }
        else{
          const res = await axios.post(`${REST_API_END_POINT}onboard/add-workflow`,{
            stageSubmit,savedStages,userId:userData.user_id,productWorkflow:true
           })
            if(res.data.status ==1){
              enqueueSnackbar(res.data.message,{variant:'success'})
              if(fromProducts){
                setOpenWorkflowModal(false)
                if(res.data?.workflowId){
                  onWorkflowCreated(res.data?.workflowId?.id)
                }
              }else{
                navigate(PATH_DASHBOARD.onboard.productWorkflow)
              }
              setSavedStages(null)
            }else{
              enqueueSnackbar(res.data.message,{variant:'error'})
              if(fromProducts){
                setOpenWorkflowModal(false)
              }else{
                navigate(PATH_DASHBOARD.onboard.productWorkflow)
              }
              setSavedStages(null)
            }
        }
      
    } catch (error) {
        console.log(error ,'error in adding new onboard')
    }finally{
      setIsSaving(false)
    }
 }
 const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    const inputValue = type === 'checkbox' ? checked : value;

    setStageSubmit((prevStageSubmit) => ({
      ...prevStageSubmit,
      [name]: inputValue,
    }));
  };

const cancelOnboard=()=>{
    setSavedStages(null)
    if(fromProducts){
      setOpenWorkflowModal(false)
    }else{
      navigate(PATH_DASHBOARD.onboard.productWorkflow)
    }
}

const handleBackConfirmYes = async () => {
  setOpenBackConfirm(false);
  sumbmitOnboard({ preventDefault: () => {} });
};

const handleBackConfirmNo = () => {
  setOpenBackConfirm(false);
  cancelOnboard();
};

const handleBackButtonClick = (e) => {
  e.preventDefault();
  setOpenBackConfirm(true);
};
 

let editedSkills =editStage?.skills
let editedServices =editStage?.services

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      stage_name: isEdit? editStage?.stage_name:(editStage?.stage_name||''),
      stage_type: stageDetail,
      template:isEdit ?initialtemplate:(editStage?.template||[]),
      questions:isEdit ? initialQuestionaire: (editStage?.questions||[]),
      documents: isEdit ?initialDocuments: (editStage?.documents||[]),
      agreements: isEdit? initialAgreement: (editStage?.agreements||[]),
      bank_details: isEdit?initialBankDocs:(editStage?.bank_details||[]),
      partnerTypes:isEdit ? initialPartner : (editStage?.partnerTypes||[]),
      skills:isEdit ? !empty(initialSkills) ?initialSkills: editedSkills :(editedSkills||[]),
      services:isEdit ? (!empty(initialService) ? initialService : editedServices) :(editedServices||null),
      groups:isEdit ? initialgroup: (editStage?.groups||[]),
      managers:isEdit ? initialManagers :(editStage?.managers||[]),
      type_of_stage:isEdit ? editStage?.type_of_stage=="Automatic"?'Automatic':'Manual': "Automatic",
      description: isEdit? editStage?.description :(editStage?.description||''),
      // description: isEdit? editStage?.exit_message :(editStage?.description||''),
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
       
      try {
        let updatedStages=null       
        if(editStage){
          const storedStages = savedStages.filter(stage=> stage.id!==editStage.id)
          const id = Math.round(moment().valueOf() / 1000);
          const service_name = allServices?.find(item=>item?.id == values.services?.id)?.name || ''
          const valuesWithId = { ...values, new_service_name: service_name, id, oldId:editStage.oldId};
          console.log("#########################111Values",values);
          console.log("#########################111valuesWithId",valuesWithId); 
          console.log("#########################111storedStages",storedStages);
          updatedStages = [...storedStages, valuesWithId];
          console.log(updatedStages,'%%%%%%%%%%%%%%%updatedStages')
          setSavedStages(updatedStages)
        } else {
          const id = Math.round(moment().valueOf() / 1000) 
          const service_name = allServices?.find(item=>item?.id == values.services?.id)?.name || ''
          const valuesWithId = { ...values, new_service_name: service_name, id }
          updatedStages = Array.isArray(savedStages) ? [...savedStages, valuesWithId] : [valuesWithId];
          setSavedStages(updatedStages)
        }
        // setSavedStages(updatedStages)
        resetForm()
        setEditStage(null)
        setSubmitting(false)
        setEditStage(null)
        setOpenModal(!openModal)
      } catch (error) {
        console.error(error)
        setSubmitting(false)
        setErrors(error)
      }
    },
  })

  const {
    errors,
    values,
    touched,
    handleSubmit,
    setValues,
    isSubmitting,
    setFieldValue,
    getFieldProps,
  } = formik
  const handleNewRequest = async () => {
    try {
      if(newDocument==''){
        enqueueSnackbar('Please fill the field',{variant:'warning'})
        return
      }
      else{
      let res = await axios.post(
        `${REST_API_END_POINT}onboard/add-new-document`,
        {
          newDocument,
          userId: userData.user_id,
          userType: userData.user_type,
        },
      )
      if (res.data.status == 1) {
        setDocuments((prev) => [...prev, res.data.documentRequestRes])
        setNewDocument('')
        // enqueueSnackbar(res.data.message,{ variant: 'success' })
      } else {
        enqueueSnackbar('Failed to save', { variant: 'error' })
      }
    }
    } catch (error) {
      console.log(error, 'error in adding new doc')
    }
  }
  const HandleModalClose = () => {
    // Close the modal and clear any stage being edited so that the next
    // "add" action starts with a clean form.
    setOpenModal(false)
    setEditStage(null)
  }
  const handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const items = Array.from(savedStages);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setSavedStages(items);
  };

  return (
    <Page title="Onboard:Create New Product Workflow | Sign-Wise Solution">
      {loading ?
        <CircularProgress color="primary" variant="indeterminate" />
      :
      (!openModal ? (
        <Container>
          {fromProducts ? '' :
            <Stack
              sx={{ cursor: 'pointer' }}
              onClick={handleBackButtonClick}
              flexDirection={'row'}
              // marginTop={-2}
            >
              <Button variant="outlined" onClick={handleBackButtonClick}>
                <KeyboardBackspaceOutlined sx={{ width: 20, height: 20, mr: 1 }} />
                Back to all Product workflows
              </Button> 
            </Stack>
          }
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mt={2}
          >
            <HeaderBreadcrumbs heading={isEdit ?"Edit Production Workflow": "Create New Production Workflow"} />
          </Stack>
              {/* <FormikProvider value={formik}>
                <Form noValidate autoComplete="off" onSubmit={handleSubmit}> */}
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3 }}>
                      <Stack spacing={3}>
                        <TextField
                          fullWidth
                          id='name'
                          name='name'
                          label="Name"
                          value={stageSubmit.name}
                          onChange={handleInputChange}
                        />
                      
                        <Card sx={{ display: 'flex', alignItems: 'center', p: 3 }}>
                        <DragDropContext onDragEnd={handleDragEnd}>
                          <Droppable droppableId="droppable">
                            {(provided) => (
                          <Grid container spacing={3} {...provided.droppableProps}
                          ref={provided.innerRef}>
                            {savedStages?.length >0 && savedStages?.map((data,index) => {                                                                  
                              return (
                                <Draggable
                                key={data.id}
                                draggableId={data.id.toString()}
                                index={index}
                              >
                                {(provided) => (
                                  <Grid key={data.id} item xs={12} sm={6} md={6} lg={8} xl={8}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}>
                                  <Card
                                    key={data.id}
                                    sx={{
                                      minWidth: 160,
                                      transition: 'transform 0.2s',
                                      '&:hover': {
                                        transform: 'scale(1.02)',
                                      },
                                    }}
                                  
                                  > 
                                    {/* <CardMediaStyle> */}
                                    
                                        <DeleteOutlineOutlined
                                          onClick={()=>handleDeleteStage(data.id)}
                                          sx={{
                                            zIndex: 10,
                                            top: 10,
                                            right: 16,
                                            color: theme.palette.primary.light,
                                            position: 'absolute',
                                            cursor: 'pointer',
                                          }}
                                        />
                                        <Edit
                                        onClick={()=>handleEditStage(data)}
                                        sx={{
                                            zIndex: 10,
                                            top: 10,
                                            left: 16,
                                            color: theme.palette.secondary.light,
                                            position: 'absolute',
                                            cursor: 'pointer',
                                          }}/>
                                    {/* </CardMediaStyle> */}
                                    <Box sx={{mt:2, p: 2, textAlign: 'center', justifyContent: 'center' }}>
                                      <Stack justifyContent={'center'} alignItems={'center'}>
                                        <Typography variant="caption" align="center">
                                          {  data?.stage_name}
                                        </Typography>
                                        <Typography variant="overline" align="center">
                                          {data?.stage_type.label}
                                        </Typography>
                                      </Stack>
                                    </Box>
                                    
                                    <Stack m={2} justifyContent={'center'} alignItems={'center'}>
                                      <Tooltip title={`Service : ${data?.new_service_name || data?.service_name || ''}`}>
                                        <Typography variant="caption" align="center" sx={{ color: 'yellow' }}>
                                          {data?.new_service_name || data?.service_name || ''}
                                        </Typography>
                                      </Tooltip>
                                      <Typography sx={{color:'GrayText'}} variant='caption' textAlign={'center'}>{data?.stage_type?.session}</Typography>
                                      </Stack>
                                      </Card>
                                    </Grid>
                                    )}
                                </Draggable>
                                    )
                                  })}
                                {provided.placeholder}
                                </Grid>
                                )}
                          </Droppable>
                      </DragDropContext>
                        </Card>
                        {/* <FormControlLabel
                          control={
                              <Switch
                              id='isDefault'
                              name='isDefault'
                              checked={stageSubmit.isDefault}
                              onChange={handleInputChange}
                            />
                          }
                          label="Default onboarding workflow"
                          sx={{ mb: 2 }}
                        /> */}
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={3}>
                      <Card
                        sx={{
                          p: 2,
                          display: 'flex',
                          flexDirection: 'row',
                          gap: 2,
                          justifyContent: 'space-around',
                        }}
                      >
                        <Tooltip placement='top' 
                        title={' This stage is for the client workflows such as catalog workflows. '}>
                        <Button
                          variant="outlined"
                          onClick={() => ClickClientFacing()}
                        >
                          Client-Facing stages
                        </Button>
                        </Tooltip>
                        {/* <Tooltip placement='top' title={' This stage is solely for the team members and staffs.'}>
                        <Button variant="outlined" onClick={() => ClickInternal()}>
                          Internal stage
                        </Button>
                        </Tooltip> */}
                        {/* <Button variant="outlined" onClick={()=>{ 
                          if(savedStages.length ==0){
                            enqueueSnackbar('Please add at least one client-facing stage to the onboarding workflow.',{variant:'warning'})
                          }else{
                          savedStages.length >0 &&HandleClickToForm(ACTIONSTAGE[0])
                          }
                          }}>
                          Action Stages
                        </Button> */}

                </Card>
                {clickClient && (
                  <MenuList>
                    {ClientFacing?.map((option) => (
                      <MenuItem
                        onClick={() => HandleClickToForm(option)}
                        key={option.id}
                      >
                        {option.icon} {option.label}
                      </MenuItem>
                    ))}
                  </MenuList>
                )}
                {internal && (
                  <MenuList>
                    {InternalData?.map((option) => (
                      <MenuItem
                        key={option.id}
                        onClick={() => HandleClickToForm(option)}
                      >
                        {option.icon} {option.label}
                      </MenuItem>
                    ))}
                  </MenuList>
                )}
              </Stack>
            </Grid>
          </Grid>
          <Box
            sx={{
              mt: 3,
              display: 'flex',
              justifyContent: 'flex-start',
              gap: 1,
            }}
          >
            <Button variant="contained"
             type="submit" 
             disabled={!stageSubmit.name.trim()}
             onClick={sumbmitOnboard}>
              Save
            </Button>
            <Button variant="outlined"  onClick={handleBackButtonClick}>
              Cancel
            </Button>
          </Box>
          {/* </Form>
                    </FormikProvider> */}

           {/* Auto-save confirmation dialog */}
           <Dialog
            open={openBackConfirm}
            onClose={() => setOpenBackConfirm(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Go back?</DialogTitle>
            <DialogContent>
              <Typography variant="body1">
                Do you want to auto save this workflow before going back?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleBackConfirmNo} variant="outlined" color="primary">
                No, Go Back
              </Button>
              <Button onClick={handleBackConfirmYes} variant="contained" color="primary">
                Yes, Auto Save
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      ) : (
        <Container>
          <HeaderBreadcrumbs heading={stageDetail?.label} />
          {isLoadingSkills ? <LoadingScreen /> : 
          <FormikProvider value={formik}>
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={10}>
                  <Card sx={{ p: 3 }}>
                    <Stack spacing={3}>
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      > 
                  
                        <TextField
                          fullWidth
                          label="Stage Name"       
                          id='stageName'                  
                          // {...getFieldProps('stage_name')}
                          // value={values.stage_name}
                          value={ values.stage_name||""}
                            onChange={(event, newValue) =>
                              setFieldValue('stage_name', event.target.value)
                            }
                          error={Boolean(
                            touched.stage_name && errors.stage_name,
                          )}
                          helperText={touched.stage_name && errors.stage_name}
                        />

                        {stageDetail?.label == 'Data Collection' ? (
                          <Autocomplete
                            multiple
                            fullWidth
                            id="combo-box-demo-templates"
                            options={(templates || []).sort((a, b) => 
                              alphanumericCompare(a?.name || '', b?.name || '')
                            )}                         
                            isOptionEqualToValue={(option, value) => option.id === value.id}                          
                            value={ values.template||[]}
                            onChange={(event, newValue) =>
                              setFieldValue('template', newValue)
                            }
                            renderInput={(params) => (
                              <TextField {...params} label="Select Templates"
                              error={Boolean(
                                touched.template && errors.template,
                              )}
                              helperText={touched.template && errors.template} />
                            )}
                            getOptionLabel={(option) => option.name}
                          />
                        ) : stageDetail?.label === 'Sign Agreement' ? (
                          <Autocomplete
                            multiple
                            fullWidth
                            id="combo-box-demo-agreements"
                            options={(signAgreement || []).sort((a, b) => 
                              alphanumericCompare(a?.name || '', b?.name || '')
                            )}
                            value={values.agreements||[]}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={(event, newValue) =>
                              setFieldValue('agreements', newValue)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Agreements"
                                error={Boolean(
                                  touched.agreements && errors.agreements,
                                )}
                                helperText={touched.agreements && errors.agreements}
                              />
                            )}
                            getOptionLabel={(option) => option.name}
                          />
                        ) : stageDetail?.label === 'Questionnaire' ? (
                          <Autocomplete
                            multiple
                            fullWidth
                            id="combo-box-demo-questions"
                            options={(questions || []).sort((a, b) => 
                              alphanumericCompare(a?.name || '', b?.name || '')
                            )}
                            value={values.questions||[]}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={(event, newValue) =>
                              setFieldValue('questions', newValue)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Questionaire"
                                error={Boolean(
                                  touched.questions && errors.questions
                                )}
                                helperText={touched.questions && errors.questions}
                              />
                            )}
                            getOptionLabel={(option) => option.name}
                          />
                        ) : stageDetail?.label === 'Action Stage' ? (null)
                        : (
                          <TextField
                            fullWidth
                            multiline
                            minRows={2}
                            label={stageDetail?.label}
                            value={`Clients will asked to provide ${stageDetail.shot} information`}
                          />
                        )}
                      </Stack>
                      {stageDetail.label == 'Action Stage' &&(
                          <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                        >
                        {openClientAutoComplete &&
                        <Autocomplete                           
                            fullWidth
                            id="combo-box-demo-partnerTypes"
                            options={(partnerTypes || []).sort((a, b) => 
                              alphanumericCompare(a?.name || '', b?.name || '')
                            )}
                            value={values?.partnerTypes||[]}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={(event, newValue) =>
                              setFieldValue('partnerTypes', newValue)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Client Types"
                              />
                            )}
                            getOptionLabel={(option) => option.name}
                          />}
                          {/* {openGroup &&
                          <Autocomplete
                            multiple
                            fullWidth
                            id="combo-box-demo-groups"
                            options={groups ? groups : []}
                            value={values.groups||[]}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={(event, newValue) =>
                              setFieldValue('groups', newValue)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Groups"
                              />
                            )}
                            getOptionLabel={(option) => option.name}
                          />} */}
                          {openRelationAutoComplete&&
                          <Autocomplete
                            multiple
                            fullWidth
                            id="combo-box-demo-managers"
                            options={(managers || []).sort((a, b) => 
                              alphanumericCompare((a?.first_name || '') + (a?.last_name || ''), (b?.first_name || '') + (b?.last_name || ''))
                            )}
                            value={values.managers||[]}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={(event, newValue) =>
                              setFieldValue('managers', newValue)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Relationship Managers"
                              />
                            )}
                            getOptionLabel={(option) => option.first_name+option.last_name}
                          />}
                          </Stack>
                        )}
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                
                        {(stageDetail.label === 'Data Collection'&& stageDetail.session ==='onboard_stages') ? ( 
                          <>
                            <Autocomplete
                              multiple
                              fullWidth
                              id="combo-box-demo-documents"
                              options={(skills || []).sort((a, b) => 
                              alphanumericCompare(a?.name || '', b?.name || '')
                            )}
                              value={values.skills||[]}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              onChange={(event, newValue) =>
                                setFieldValue('skills', newValue)
                              }
                              renderInput={(params) => (
                                <TextField {...params} label="Select Skills" />
                              )}
                              getOptionLabel={(option) => option.name}
                            />
                            <Autocomplete
                              // multiple
                              fullWidth
                              id="combo-box-demo-documents"
                              options={allServices}
                              value={values.services||null}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              onChange={(event, newValue) =>
                                setFieldValue('services', newValue)
                              }
                              renderInput={(params) => (
                                <TextField {...params} label="Select service"
                                  error={Boolean(touched.services && errors.services)}
                                  helperText={touched.services && errors.services}
                                />
                              )}
                              getOptionLabel={(option) => option.name}
                            />
                          </>
                        ) : stageDetail?.label === 'Bank Information' ? (
                          <>
                          
                          <Autocomplete  
                            multiple                         
                            fullWidth
                            id="combo-box-demo-bank_details"
                            options={[...BANK_DETAILS].sort((a, b) => 
                              alphanumericCompare(a?.name || '', b?.name || '')
                            )}
                            value={values.bank_details}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={(event, newValue) =>{
                              
                              setFieldValue('bank_details', newValue)
                            }
                            }
                            renderInput={(params) => (
                              <TextField required
                                {...params}
                                label="Select Bank Details"
                                error={Boolean(
                                  touched.bank_details && errors.bank_details,
                                )}
                                helperText={touched.bank_details && errors.bank_details}
                              />
                            )}
                            getOptionLabel={(option) => option.name}
                          />
                          </>
                          
                        ) : null}
                      </Stack>
                      <Stack
                        sx={{ justifyContent: 'space-around' }}
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        {/* {stageDetail?.label == 'Data Collection' && (
                          <Stack>
                            <Typography variant="body1">
                              {' '}
                              Create new document request
                            </Typography>
                            <TextField
                              fullWidth
                              label="Document"
                              value={newDocument}
                              onChange={(event) =>
                                setNewDocument(event.target.value)
                              }
                            />
                            <Stack
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                mt: 1,
                              }}
                            >
                              <Button
                                size="small"
                                variant="contained"
                                onClick={handleNewRequest}
                                sx={{ width: 'fit-content' }}
                              >
                                Create
                              </Button>
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() => setNewDocument('')}
                                sx={{ width: 'fit-content' }}
                              >
                                Cancel
                              </Button>
                            </Stack>
                          </Stack>
                        )} */}
                    
                        {stageDetail.label =='Action Stage' ? (
                                            <Grid item sx={{ marginTop: '20px' }}>
                                            <Button
                                              sx={{ marginTop: '10px' }}
                                              ref={buttonRef}
                                              onClick={() => setPopoverAnchor(buttonRef.current)}
                                        
                                              variant="contained"
                                            >
                                              Actions ***
                                            </Button>
                                            <Popover
                                              sx={{ marginTop: '40px' }}
                                              open={popoverAnchor}
                                              anchorEl={popoverAnchor}
                                              onClose={() => setPopoverAnchor(null)}
                                              anchorOrigin={{
                                                vertical: 'center', 
                                                horizontal: 'center',
                                              }}
                                              transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                              }}
                                            >
                                              <Paper
                                                sx={{
                                                  maxWidth: '300px', 
                                                  maxHeight: 210,
                                                  overflow: 'auto',
                                                  '&::-webkit-scrollbar': {
                                                    width: '0.4em',
                                                  },
                                                  '&::-webkit-scrollbar-track': {
                                                    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                                                    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                                                  },
                                                  '&::-webkit-scrollbar-thumb': {
                                                    backgroundColor: 'rgba(0,0,0,.1)',
                                                    borderRadius: '4px',
                                                  },
                                                }}
                                              >
                                                <Stack direction="column" spacing={2} sx={{ p: 2 }}>
                                                  <Typography
                                                    onClick={()=>setOpenClientAutoComplete(!openClientAutoComplete)}
                                                    component="div"
                                                    variant="body1"
                                                    sx={{
                                                      cursor: 'pointer',
                                                      textAlign: 'left',
                                                      color: 'primary.main',
                                                      '&:hover': { color: 'white' },
                                                    }}
                                                  >
                                                  Set Client Type
                                                  </Typography>

                                                  {/* <Typography
                                                    onClick={()=>setOpenGroup(!openGroup)}
                                                    variant="body1"
                                                    component="div"
                                                    sx={{
                                                      cursor: 'pointer',
                                                      textAlign: 'left',
                                                      color: 'primary.main',
                                                      '&:hover': { color: 'white' },
                                                    }}
                                                  >
                                                    Add to groups 
                                                  </Typography> */}
                                              
                                                  <Typography    
                                                  onClick={()=>setOpenRelationAutoComplete(!openRelationAutoComplete)}                                               
                                                    variant="body1"
                                                    component="div"
                                                    sx={{
                                                      cursor: 'pointer',
                                                      textAlign: 'left',
                                                      color: 'primary.main',
                                                      '&:hover': { color: 'white' },
                                                    }}
                                                  >
                                                  Set Relationship Managers
                                                  </Typography>
                                                </Stack>
                                              </Paper>
                                            </Popover>
                                          </Grid>
                        ):(
                        <FormControl>
                          <FormLabel id="demo-radio-buttons-group-label">
                            
                          </FormLabel>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="Automatic"
                            // value={values.type_of_stage}
                            onChange={(event, newValue) =>
                              setFieldValue('type_of_stage', newValue)
                            }
                            name="radio-buttons-group"
                          >
                            <FormControlLabel
                              value="Automatic"
                              control={<Radio />}
                              label="Automatic Stage"
                            />
                            {/* <FormControlLabel
                              value="Manual"
                              control={<Radio />}
                              label="Manual Review Stage"
                            /> */}
                          </RadioGroup>
                        </FormControl>
                        )}
                      </Stack>
                      {stageDetail.label !=='Action Stage' &&(
                        <>
                          { console.log("values.description############",values)}
                      <LabelStyle>Message (Optional)</LabelStyle>
                      <TextField
                        fullWidth
                        multiline
                        minRows={3}
                        maxRows={7}
                        label="Description"
                        // {...getFieldProps('description')}
                        value={ values.description||""}
                        onChange={(event, newValue) =>
                          setFieldValue('description', event.target.value)
                        }
                        error={Boolean(
                          touched.description && errors.description,
                        )}
                        helperText={touched.description && errors.description}
                      />
                      You can set the message that will be displayed when client
                      exits this stage
                      </>
                      )}
                      <Box
                        sx={{
                          mt: 3,
                          display: 'flex',
                          justifyContent: 'flex-end',
                          gap: 1,
                        }}
                      >
                        <LoadingButton
                          type="submit"
                          variant="contained"
                          loading={isSubmitting}
                        >
                          Save
                        </LoadingButton>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            HandleModalClose()
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Stack>
                  </Card>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>}
        </Container>
      ))}
    </Page>
  )
}
